import { Router, NavigationEnd } from '@angular/router';
import { PaypalService } from './paypal.service';
import { Component, HostBinding } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { GlobalService } from './global.service';
import { defs } from './defs';

@Component({
	// tslint:disable-next-line
	selector: 'body',
	templateUrl: './app.component.html'
})
export class AppComponent {
	@HostBinding('style.overflow') overflow = 'hidden';
	constructor(private globalService: GlobalService, private paypalService: PaypalService, private router: Router, private log: NGXLogger) {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd && (event.url.startsWith('/profile') || event.url.startsWith('/register'))) {
				this.overflow = 'auto';
			} else {
				this.overflow = 'hidden';
			}
		});
		this.globalService.config.subscribe(cfg => {
			if(cfg.apiVersion !== defs.apiVersion) {
				log.fatal('apiVersion mismatch: exp: ' + defs.apiVersion + ', but BE: ' + cfg.apiVersion )
			}
		});
		this.paypalService.loadPaypalScript();
	}
}
